import React, { useState } from 'react';

const NJ_TAX_RATE = 0.06625; // 6.625% NJ sales tax rate

function SalesTaxCalculator() {
    const [amount, setAmount] = useState('');
    const [isReverse, setIsReverse] = useState(false);
    const [result, setResult] = useState(null);

    const calculateTax = (e) => {
        e.preventDefault();
        const numAmount = parseFloat(amount);

        if (isNaN(numAmount)) return;

        if (isReverse) {
            const preWidth = numAmount / (1 + NJ_TAX_RATE);
            const taxAmount = numAmount - preWidth;
            setResult({
                original: preWidth,
                tax: taxAmount,
                total: numAmount
            });
        } else {
            const taxAmount = numAmount * NJ_TAX_RATE;
            setResult({
                original: numAmount,
                tax: taxAmount,
                total: numAmount + taxAmount
            });
        }
    };

    return (
        <div>
            <div className="calculator-header">
                <h3>Sales Tax Calculator</h3>
                <div className="mode-switch">
                    <label className="switch">
                        <input
                            type="checkbox"
                            checked={isReverse}
                            onChange={(e) => setIsReverse(e.target.checked)}
                        />
                        <span className="slider round"></span>
                    </label>
                    <span className="mode-label">
                        {isReverse ? 'Reverse Calculation' : 'Standard Calculation'}
                    </span>
                </div>
            </div>

            <form onSubmit={calculateTax}>
                <div className="input-group">
                    <label>{isReverse ? 'Total Amount:' : 'Purchase Amount:'}</label>
                    <div className="input-with-icon">
                        <span className="currency-symbol">$</span>
                        <input
                            type="number"
                            step="0.01"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="0.00"
                            autoFocus
                        />
                    </div>
                </div>
                <button type="submit" className="calculate-btn">Calculate</button>
            </form>

            {result && (
                <div className="results">
                    <div className="result-item">
                        <span className="result-label">{isReverse ? 'Pre-tax Amount:' : 'Original Amount:'}</span>
                        <span className="result-value">${result.original.toFixed(2)}</span>
                    </div>
                    <div className="result-item">
                        <span className="result-label">Sales Tax (6.625%):</span>
                        <span className="result-value">${result.tax.toFixed(2)}</span>
                    </div>
                    <div className="result-item total">
                        <span className="result-label">Total Amount:</span>
                        <span className="result-value">${result.total.toFixed(2)}</span>
                    </div>
                </div>
            )}
        </div>
    );
}

export default SalesTaxCalculator;
